import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import WhatWeAccept from "@/pages/WhatWeAccept";
import DonateItems from "@/pages/DonateItems";
import ShopFurniture from "@/pages/ShopFurniture";
import ApplyToShop from "@/pages/ApplyToShop";
import SupportPilot from "@/pages/SupportPilot";
import About from "@/pages/About";
import ServiceArea from "@/pages/ServiceArea";
import Contact from "@/pages/Contact";
import Partners from "@/pages/Partners";
import Volunteers from "@/pages/Volunteers";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";

export const lenisRef = { current: null };

function SmoothScroll({ children }) {
  const location = useLocation();
  const rafRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    lenisRef.current = lenis;
    const raf = (time) => {
      lenis.raf(time);
      rafRef.current = requestAnimationFrame(raf);
    };
    rafRef.current = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafRef.current);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <SiteHeader />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/what-we-accept" element={<WhatWeAccept />} />
              <Route path="/donate-items" element={<DonateItems />} />
              <Route path="/shop" element={<ShopFurniture />} />
              <Route path="/apply-to-shop" element={<ApplyToShop />} />
              <Route path="/support" element={<SupportPilot />} />
              <Route path="/about" element={<About />} />
              <Route path="/service-area" element={<ServiceArea />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/volunteers" element={<Volunteers />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
          </main>
          <SiteFooter />
          <Toaster position="top-center" richColors />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
